module.exports = __webpack_public_path__ + "img/social4espanol.47ad3c12.png";